var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16168",
    "data-name": "Group 16168",
    transform: "translate(-1536 -143.507)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3422",
    "data-name": "Rectangle 3422",
    width: 30,
    height: 30,
    transform: "translate(1536 143.507)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16160",
    "data-name": "Group 16160",
    transform: "translate(1538.676 146.462)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11418",
    "data-name": "Path 11418",
    d: "M28.94,7.541a.345.345,0,0,0-.279-.235l-5.786-.841L20.289,1.222a.36.36,0,0,0-.62,0L17.08,6.465l-5.786.841A.345.345,0,0,0,11.1,7.9L13.879,10.6l.483-.495L12.087,7.889l5.273-.766a.345.345,0,0,0,.26-.189l2.358-4.779,2.358,4.78a.345.345,0,0,0,.26.189l5.273.766-3.816,3.718a.345.345,0,0,0-.1.306l.9,5.252L23.592,16.5l-.321.611,1.882.99a.345.345,0,0,0,.5-.364l-.988-5.761L28.853,7.9a.345.345,0,0,0,.087-.354Z",
    transform: "translate(-6.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11419",
    "data-name": "Path 11419",
    d: "M23.244,31.952l1.036.345a.345.345,0,0,0,.451-.279l.345-2.41A1.381,1.381,0,0,0,22.9,28.3l-1.185.863L21.95,27l2.952-1.64a.345.345,0,0,0,.178-.3V23.681a.345.345,0,0,0-.513-.3l-3.381,1.878a1.7,1.7,0,0,0,.1-.54,1.727,1.727,0,1,0-2.134,1.673l-3.9,2.169a.345.345,0,0,0-.178.3v1.381a.345.345,0,0,0,.523.3l2.87-1.722-.27,2.97-2.64,1.979a.345.345,0,0,0-.138.276v1.381a.345.345,0,0,0,.55.276l7.257-5.362-.2,1.23A.345.345,0,0,0,23.244,31.952Zm-4.726-7.235a1.036,1.036,0,1,1,1.036,1.036,1.036,1.036,0,0,1-1.036-1.036ZM16.1,34.738v-.524l2.625-1.968A.345.345,0,0,0,18.864,32l.345-3.8a.345.345,0,0,0-.522-.327l-2.93,1.758v-.568l8.634-4.8v.591L21.46,26.487a.345.345,0,0,0-.175.264l-.345,3.108a.345.345,0,0,0,.546.317L23.3,28.854a.691.691,0,0,1,1.09.656l-.286,2-.364-.121.3-1.781a.345.345,0,0,0-.546-.335Z",
    transform: "translate(-8.995 -14.363)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11420",
    "data-name": "Path 11420",
    d: "M0,0H1.727V.691H0Z",
    transform: "matrix(0.8, -0.6, 0.6, 0.8, 3.788, 21.823)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11421",
    "data-name": "Path 11421",
    d: "M0,0H4.566V.691H0Z",
    transform: "matrix(0.832, -0.555, 0.555, 0.832, 1.339, 20.429)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11422",
    "data-name": "Path 11422",
    d: "M0,0H2.926V.691H0Z",
    transform: "translate(1.324 17.472) rotate(-34.278)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.6d14341cd124b551984135b2462a4a98.svg";
export { ForwardRef as ReactComponent };